import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 5000, suffix: "+", label: "Happy Pets" },
  { value: 2500, suffix: "+", label: "Homes Served" },
  { value: 4.9, suffix: "★", label: "Rating", decimal: true },
  { value: 30, suffix: " Min", label: "Average Arrival" },
];

function Counter({ value, suffix, decimal }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const dur = 1600, start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(decimal ? +(value * eased).toFixed(1) : Math.floor(value * eased));
      if (p < 1) requestAnimationFrame(tick);
      else setN(value);
    };
    requestAnimationFrame(tick);
  }, [inView, value, decimal]);
  return <span ref={ref}>{decimal ? n.toFixed(1) : n.toLocaleString()}{suffix}</span>;
}

export default function Statistics() {
  return (
    <section data-testid="statistics-section" className="relative py-20 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto rounded-[2.5rem] bg-woofsy-dark px-6 sm:px-14 py-14 relative overflow-hidden">
        <div className="absolute -top-20 -right-10 w-72 h-72 rounded-full bg-woofsy-primary/30 blur-3xl" />
        <div className="absolute -bottom-24 -left-10 w-72 h-72 rounded-full bg-woofsy-secondary/20 blur-3xl" />
        <div className="relative grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <motion.div key={s.label} data-testid={`stat-${i}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.12 }} className="text-center">
              <p className="font-heading font-extrabold text-4xl sm:text-5xl text-woofsy-accent">
                <Counter value={s.value} suffix={s.suffix} decimal={s.decimal} />
              </p>
              <p className="mt-2 text-woofsy-secondary/90 text-sm font-medium">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
